import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {PdfJsViewerComponent} from 'ng2-pdfjs-viewer';
import {get, set, includes, filter} from 'lodash';
import {FileService} from '@ispm-client/modules/file-module/services/file.service';
import {INLPHighlightConfig} from '@ispm-client/modules/file-module/Interfaces';
import {BundleCall} from "@ispm-client/modules/aggregator/services";
import {zip} from 'rxjs/observable/zip';
import {CORE_ACTIONS} from "@ispm/core/constants/core-actions.constant";
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {EventService} from '@ispm-client/modules/events/services/event.service';
import { AttachmentService } from '@ispm/migration/services/attachment.service';

@Component({
  selector: 'gen-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileViewerComponent implements OnInit, OnChanges {

  downloadLink: string;
  isDownloadable: boolean;
  pdfFileNotUploaded: boolean = true;
  _fileResourceId: string;
  imageBlobUrl: any;
  videoBlobUrl: any;
  mimeType: any;
  @Input() downloading: boolean = false;
  @Input() loading: boolean = false;
  @Input() nlpConfig: INLPHighlightConfig;
  @Input() hasNLPHighLights: boolean = false;
  @Input() file: any;
  @Input() fileBase64Content: any;
  @Input() nlpTransformed: any;
  @Output() onDownloadFile: EventEmitter<any> = new EventEmitter();
  @Input() reviewExtractionKey: boolean = false;
  @Input() nlpType: string = null;
  selectedETypes: any[];
  supportedETypes: any[];
  @Input() currentFinding: number;
  private _changeHighlight: number;
  private _fileScroll: any;

  @Input()
  set fileResourceId(res: string) {
    this._fileResourceId = res;
  }

  get fileResourceId(): string {
    return this._fileResourceId;
  }

  get changeHighlight(): number {
    return this._changeHighlight;

  }

  @Input()
  set findingData(input: any){
    this._changeHighlight = input[0];
    this._fileScroll = input[1];
    if (this.hasNLPHighLights && this.nlpTransformed)
      this.showNLPHighlightsOnFile('#nlp-highlight-file-viewer', get(this.nlpConfig, 'basedOnTransformations'));

  }

  get fileScroll() {
    return this._fileScroll;
  }

  _inlinePdfViewer: PdfJsViewerComponent;

  @ViewChild('inlinePdfViewer', {static: false})
  public set inlinePdfViewer(_inlinePdfViewer: PdfJsViewerComponent) {
    if (_inlinePdfViewer) {
      this._inlinePdfViewer = _inlinePdfViewer;
      this.intiFileRendering();

    }
  };

  @ViewChild('inlineTextViewer', {static: false})
  public inlineTextViewer: ElementRef;

  constructor(private _attachments: AttachmentService,
              private _fileService: FileService,
              private _bundleCall: BundleCall,
              private _store: Store<IgenomicsState>,
              private _chnageDetector: ChangeDetectorRef,
              private _eventService: EventService) {
  }

  ngOnInit() {
  }

  /**
   * emitter for download file
   */
  emitDownloadFile() {
    this.onDownloadFile.emit(this.file);
  }

  /**
   * get image mime type
   * @param type
   */
  private getMIMEType(type) {
    if (this.file.fileType === 'image') {
      return `image/${type.toLowerCase()}`;
    } else if (this.file.fileType === 'video') {
      return `video/${type.toLowerCase()}`;
    }
  }

  fetchFileResource() {
    const fileResourcePayload = [];
    const fileBase64 = this._fileService.getFileData(this._fileResourceId);
    fileResourcePayload.push({
      "queryString": `_id=${this._fileResourceId}`,
      "targetResource": "FileResource"
    });

    const fileData = this._bundleCall.searchCall({queries: fileResourcePayload});
    const fileResources = zip(fileBase64, fileData);
    fileResources.subscribe(val => {
      this.fileBase64Content = val[0];
      const fileData = get(val[1][0], 'response.entry[0].resource');
      this.file = fileData;
      this._chnageDetector.markForCheck();
      this._store.dispatch({
        type: CORE_ACTIONS.SET_LOADER,
        payload: false
      });
    })
  }

  /**
   * Show NLP highlights on report
   * @param selector
   */
  private showNLPHighlightsOnFile(selector, basedOnTransformations, sourceText?: any) {
    let nlpViewContainer = document.querySelector(selector);
    this.supportedETypes = get(this.nlpConfig, 'eTypes', []);
    this.selectedETypes = this.selectedETypes || this.supportedETypes;
    this._chnageDetector.markForCheck();
    if (basedOnTransformations) {
      nlpViewContainer = document.querySelector(selector);
      if (nlpViewContainer) {
        nlpViewContainer.innerHTML = get(this.nlpTransformed, 'transformations[0].text');
        let excludeHighlights = filter(this.supportedETypes, function (eType) {
          return !this.selectedETypes.includes(eType);
        }.bind(this));
        if (excludeHighlights && excludeHighlights.length > 0) {
          excludeHighlights.forEach(title => {
            document.querySelectorAll(`#nlp-highlight-file-viewer span[title=${title}]`).forEach(element => {
              element.classList.add('hide-nlp-highlights');
            });
          });
        }
        this.addDynamicStylesToNLP(nlpViewContainer);
      }
    } else {
      let ranges = [];

      if (this.reviewExtractionKey && this._changeHighlight >= 0) {
        ranges = this._fileService.getNormalizeRangeperFinding(this.nlpConfig, this.nlpTransformed, this._changeHighlight, this.selectedETypes, this.nlpType);

      }
      else {
        ranges = this._fileService.getNormalizeRanges(this.nlpConfig, this.nlpTransformed, this.selectedETypes, true, this.nlpType);
      }
      // if (ranges && ranges.length > 0) {additionalconfiguration_history
      //   let instance = new Mark(nlpViewContainer);
      //   let styleConfigs = get(this.nlpConfig, 'styleConfigs');
      //   let options = {
      //     "element": get(this.nlpConfig, 'element') ? get(this.nlpConfig, 'element') : 'mark',
      //     "exclude": get(this.nlpConfig, 'exclude'),
      //     "each": function (node, range) {
      //       if (node) {
      //         node.id =  range.id;
      //         node.classList.add(range.cssClass + '-highlight');
      //         let currentNodeStyles: any = get(styleConfigs, range.cssClass.toUpperCase());
      //         currentNodeStyles = currentNodeStyles ? currentNodeStyles : get(styleConfigs, 'DEFAULT');
      //         if (styleConfigs && currentNodeStyles) {
      //           node.style = currentNodeStyles;
      //         }
      //       }
      //     }.bind(this)
      //   };
      //
      //   instance.unmark({
      //     done: function(){
      //       instance.markRanges(ranges, options);
      //     }
      //   });
      // }

      let styleConfigs = get(this.nlpConfig, 'styleConfigs');
      sourceText = get(this.nlpTransformed, 'text');
      let documentFragment = document.createDocumentFragment();
      let withoutHighlightingStart = 0;

      ranges.forEach(function (highlightRange) {
        if (highlightRange.start > withoutHighlightingStart) {
          let notHighlighted = this.createTextNode(sourceText.slice(withoutHighlightingStart, highlightRange.start));
          documentFragment.appendChild(notHighlighted);
        }
        let highlighted = this.createHighlighted(sourceText.slice(highlightRange.start, highlightRange.end), styleConfigs, highlightRange.etype);
        documentFragment.appendChild(highlighted);
        withoutHighlightingStart = highlightRange.end;
      }.bind(this));
      let lastNotHighlighted = this.createTextNode(sourceText.slice(withoutHighlightingStart));
      documentFragment.appendChild(lastNotHighlighted);
      if(nlpViewContainer){
        nlpViewContainer.innerHTML = "";
        nlpViewContainer.appendChild(documentFragment);
      }


    }
    let el = document.getElementById(this._fileScroll);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
  }

  createTextNode(str) {
    return document.createTextNode(str);
  }

  createHighlighted(str, styleConfigs, cssClass) {
    let span: any = document.createElement(get(this.nlpConfig, 'element', 'mark'));
    span.classList.add('nlp-highlight');
    span.appendChild(this.createTextNode(str));
    let currentNodeStyles: any = get(styleConfigs, cssClass.toUpperCase());
    currentNodeStyles = currentNodeStyles ? currentNodeStyles : get(styleConfigs, 'DEFAULT');
    if (styleConfigs && currentNodeStyles) {
      span.style = currentNodeStyles;
    }
    if (this.reviewExtractionKey && this._fileScroll && str.includes(this._fileScroll)) {
      span.id = (str.replace(/-/, "")).toString().trim();
    }
    return span;
  }

  intiFileRendering() {
    let fileType;
    let fileName =  get(this.file, 'name', '');
    if(fileName && fileName.includes(".")) {
      fileType = fileName.split('.')[1];
    }
    fileType = fileType ? fileType :  get(this.file, 'fileType');
    if (this.file) {
      if (includes(['txt', 'json'], fileType.toLowerCase())) {
        set(this.file, 'contentType', fileType);
        set(this.file, 'fileType', 'text');
      } else if (includes(['gif', 'png', 'jpeg', 'tiff', 'jpg'], fileType.toLowerCase())) {
        set(this.file, 'contentType', fileType);
        set(this.file, 'fileType', 'image');
      } else if (includes(['mp4', 'mov', 'avi', 'flv'], fileType.toLowerCase())) {
        set(this.file, 'contentType', fileType);
        set(this.file, 'fileType', 'video');
      } else if (includes(['pdf'], fileType.toLowerCase())) {
        set(this.file, 'contentType', fileType);
        set(this.file, 'fileType', 'pdf');
      } else if (get(this.file, 'metaData.generateDownloadUrl')) {
        this._attachments.generateDownloadURL(get(this.file, 'id')).subscribe(fileUrl => {
          this.downloadLink = fileUrl;
        });
      }
    }

    if (this.hasNLPHighLights && this.nlpTransformed) {
      setTimeout(function () {
        this.showNLPHighlightsOnFile('#nlp-highlight-file-viewer', get(this.nlpConfig, 'basedOnTransformations'));
      }.bind(this), 0);
      this.loading = false;
      return;
    }
    if (this.fileBase64Content) {
      if (this.file.fileType === 'pdf') {
        if (this._inlinePdfViewer) {
          this._inlinePdfViewer.pdfSrc = URL.createObjectURL(this._fileService.getBlob(this.fileBase64Content));
          this._chnageDetector.detectChanges();
          this._inlinePdfViewer.refresh();
        }
      } else {
        this.isDownloadable = true;
        if (this.file.fileType === 'image' || this.file.fileType === 'text' || this.file.fileType === 'video') {
          if (this.file.fileType === 'image' || this.file.fileType === 'video') {
            this.mimeType = this.getMIMEType(this.file.contentType);
          } else {
            this.mimeType = '';
          }
          //const fileBlob = this._fileService.getBlob(this.fileBase64Content, this.file.fileType === 'image' ? this.getMIMEType(this.file.contentType) : '');
          const fileBlob = this._fileService.getBlob(this.fileBase64Content, this.mimeType);
          this.isDownloadable = false;
          this.loading = true;
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            if (this.file.fileType === 'image') {
              this.imageBlobUrl = reader.result;
            } else if (this.file.fileType === 'video') {
              this.videoBlobUrl = reader.result;
            } else {
              this.inlineTextViewer.nativeElement.innerText = reader.result;
              if (this.hasNLPHighLights) {
                this.showNLPHighlightsOnFile('#nlp-highlight-file-viewer', false, reader.result);
              }
            }
            this._chnageDetector.markForCheck();
            this.loading = false;
          }, false);
          if (fileBlob) {
            if ((this.file.fileType === 'image') || (this.file.fileType === 'video')) {
              reader.readAsDataURL(fileBlob);
            } else if (this.file.fileType === 'text') {
              reader.readAsText(fileBlob);
            }

          }
        }
      }
    }
  }

  /**
   * Add dynamic style sheet to file viewer
   * @param selector
   */
  addDynamicStylesToNLP(selector) {
    let styleConfigs: any = get(this.nlpConfig, 'styleConfigs');
    if (styleConfigs) {
      let styles = '';
      for (let styleName in styleConfigs) {
        let currentNodeStyles = styleConfigs[styleName];
        if (styleName === 'DEFAULT') {
          styleName = 'ENTITY';
        }
        styles += ` .${styleName}  {${currentNodeStyles}} `;
      }

      /* Create style element */
      let cssStyle = document.createElement('STYLE');
      cssStyle.setAttribute('type', 'text/css');
      cssStyle.appendChild(document.createTextNode(styles));
      selector.appendChild(cssStyle);

      /* Append style to the head element */
      selector.appendChild(cssStyle);
    }
  }

  showSelectedHighlights() {
    this.intiFileRendering();
  }

  /**
   * On changes of properties
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'file':
          case 'fileBase64Content':
          case 'nlpConfig':
          case 'hasNLPHighLights':
          case 'nlpTransformed':
            this.intiFileRendering();
            break;
          case 'fileResourceId':
            this.fetchFileResource();
            break;
        }
      }
    }
  }

}
